import React, { useState } from 'react';

function SignUpForm({ onSignUp, address }) {

    const [signUpForm, setSignUpForm] = useState({
        email: '',
        username: ''
    })

    const handleChange = e => {
        const updated = { [e.target.name]: e.target.value }
        setSignUpForm({ ...signUpForm, ...updated });
    }

    return (
        <>
            <div className="form-group acc-form">
                <label>Wallet</label>
                <input value={address} disabled readOnly name="wallet" type="text" className="form-control" placeholder="Wallet" />
            </div>
            <div className="form-group acc-form">
                <label>Username</label>
                <input value={signUpForm.username} onChange={handleChange} name="username" type="text" className="form-control" placeholder="Username" />
            </div>
            <div className="form-group acc-form">
                <label>Email Address</label>
                <input value={signUpForm.email} onChange={handleChange} name="email" type="email" className="form-control" placeholder="Email Address" />
            </div>
            <button disabled={!signUpForm.email || !signUpForm.username} onClick={() => onSignUp(signUpForm)} className="btns accbtn-btn">Sign Up</button>
        </>
    )
}

export default SignUpForm;
